import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";

const SkeletonTable = ({ rows = 5, columns = 3 }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          {[...Array(columns)].map((_, i) => (
            <TableCell key={i}>
              <Skeleton variant="text" width={100} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(rows)].map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {[...Array(columns)].map((_, colIndex) => (
              <TableCell key={colIndex}>
                <Skeleton
                  variant="rectangular"
                  height={30}
                  sx={{ borderRadius: "6px" }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SkeletonTable;
